module.exports = __webpack_public_path__ + "static/img/124.8X60.3f758e59.jpg";